import { DataItemType, FormControlType } from "../../schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "./components/pc-upload.vue";
import mobile from "./components/mobile-upload.vue";
export const info = {
    title: "大附件",
    title_i18n: "{\"zh\": \"大附件\", \"en\": \"LargeAttachment\"}",
    type: "large-attachment",
    icon: "h-icon-all-user-o",
    dataItemType: DataItemType.Attachment,
    formControllerType: FormControlType.BigAttachment,
    group: "基础控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
